<template>
  <div v-if="filters.length">
    <SfCircleIcon
      icon="list"
      :aria-label="$t('Equipment Filters')"
      @click="isSidebarOpen = !isSidebarOpen"
      class="filters-button"
    />
    <SfSidebar
      class="sf-sidebar--right"
      :visible="isSidebarOpen"
      @close="isSidebarOpen = false"
      :title="$t('Equipment Filters')"
    >
      <SfCheckbox
        class="m-tb-10"
        :label="$t('Show all parts')"
        :selected="isShowAllParts"
        @change="showAllParts"
      />
      <SfDivider class="m-tb-15" />
      <SfCheckbox
        class="m-tb-10"
        v-for="filter in filters"
        :key="filter.Id"
        :label="`${filter.Code} - ${filter.Purpose}`"
        :selected="filter.Selected"
        :disabled="isShowAllParts"
        @change="updateFilters(filter)"
      />
    </SfSidebar>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import {
  SfCheckbox, SfSidebar, SfCircleIcon, SfDivider,
} from '@storefront-ui/vue';
import { mapFilterToResponse } from '../../utils/filters';

export default {
  name: 'ProductFilters',
  components: {
    SfCheckbox,
    SfSidebar,
    SfCircleIcon,
    SfDivider,
  },
  props: {
    conditions: {
      type: Array,
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filters: this.conditions,
      isSidebarOpen: false,
      isShowAllParts: false,
      vehicleSpecific: this.$route.params.vehicleSpecific || false,
    };
  },
  methods: {
    showAllParts(value) {
      this.isShowAllParts = value;
      this.updateProducts(true);
    },
    updateFilters(data) {
      const newFilters = this.filters.map(({ Selected, Id, ...filter }) => ({
        ...filter,
        Id,
        Selected: Id === data.Id ? !Selected : Selected,
      }));

      this.filters = newFilters;
      this.updateProducts();
    },
    updateProducts(isShowAll) {
      this.$emit('filterUpdate', true);
      this.fetchBoard({
        vehicleConditions: isShowAll ? [] : mapFilterToResponse(this.filters),
        id: this.productId,
        vehicleSpecific: this.vehicleSpecific,
      }).finally(() => {
        this.$emit('filterUpdate', false);
      });
    },
    ...mapActions({
      fetchBoard: 'level4/fetchBoard',
    }),
  },
};
</script>
<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/_helpers';
@import 'src/scss/_breakpoint.scss';

.filters-button {
  position: fixed;
  right: 30px;
  z-index: 2;
  @include flexbox-mobile {
    bottom: 80px;
  }

  @include flexbox-desktop {
    bottom: 30px;
  }
}
</style>
